import { render, staticRenderFns } from "./addproducttokenreal.vue?vue&type=template&id=04cd1c24&"
import script from "./addproducttokenreal.vue?vue&type=script&lang=js&"
export * from "./addproducttokenreal.vue?vue&type=script&lang=js&"
import style0 from "./addproducttokenreal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports